import styled from "styled-components";

const data = (type, theme) => {
  const object = {
    error: `
      background: #ff001a45;
      color: #fff;
      :after {
        background-image: url("/img/error-icon.svg");
      }
      h3 {
        color: #F64E60;
      }
    `,
  };

  return object[type];
};

export default styled.div`
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  gap: 5px;
  border-radius: 20px;
  padding: 30px;
  max-width: 500px;
  width: 100%;
  margin: 0 auto;
   
  :after {
    content: "";
    position: absolute;
    background-size: 100%;
    background-repeat: no-repeat;
    height: 200px;
    width: 200px;
    right: 30px;
    top: -37px;
    transform: rotate(-30deg);
    opacity: 0.5;
  }

  h3 {
    font-size: 1rem;
  }
  p {
    font-size: 0.8rem;
    word-break: break-word;
    z-index: 1;
  }
  > div {
    display: flex;
    flex-direction: column;
    z-index: 1;
    gap: 20px;
  }
  .action-button {
    background: unset;
    color: #FFFFFF;
    border-radius: 7px;
    cursor: pointer;
    border: 1px solid;
    padding: 8px 12px;
  }

  ${({ type, theme }) => data(type, theme)}
`;

/*
  <AlertBox type="success">
    <h3>Success</h3>
    <p>This is a success message</p>
  </AlertBox>
*/
